import React from 'react'
import { useHistory } from 'react-router-dom'

import './ContactUs.css'

const ContactUs = () => {
    const history = useHistory()
    
    return (
        <div className="join__contactUs d-flex align-center justify-center mx-40 p-40">
            <div className="w-45">
                <h2 className="">
                    DO YOU HAVE MORE QUESTIONS? <br />
                    GET IN TOUCH?
                </h2>
                <button className="border-0 outline-0 py-10 px-20 font-big font-bold mt-20 rounded" onClick={() => history.push('/contact-us')}>
                    Contact Us
                </button>
            </div>
            <p className="w-45 font-heavy font-big">
                Our team is fast and reliable to help you with any Issues or questions you may have. Our team is fast and reliable to help you with any Issues or problems  you may have
            </p>
            <button className="border-0 outline-0 py-10 px-20 font-big font-bold mt-20 rounded" onClick={() => history.push('/contact-us')}>
                Contact Us
            </button>
        </div>
    )
}

export default ContactUs
